class Monitoring.Models.RandomStringGenerator

  initialize: () ->


  @generateNewUuid: () ->
    getRandomString = ->
      Math.floor(Math.random() * 0x10000).toString(16)

    return getRandomString() + getRandomString() + "-" +
    getRandomString() + "-" + getRandomString() + "-" +
    getRandomString() + "-" + getRandomString() +
    getRandomString() + getRandomString()